import {
  CalendarDay,
  numberToCurrencyString,
  numberToPercentageString,
} from 'further-ui/utils';
import Typography from '@mui/material/Typography';
import { Vehicle } from 'further-types/lp/vehicle';
import { Column, Row } from 'further-ui/components/Layout';
import { styled } from '@mui/material';
import PerformanceCard from 'components/new/PerformanceCard';

const StyledPerformanceCard = styled(PerformanceCard)(() => ({
  flex: '1 1 0',
}));

type AssetPerformanceAggregations = {
  wasConverted: boolean;
  totalInvestmentAmountLcy: number;
  totalCurrentValueLcy: number;
  totalCurrentUnrealisedValueLcy: number;
  totalCurrentRealisedValueLcy: number;
  grossIRR: number | null;
  grossMOIC: string;
  firstInvestmentDate: CalendarDay | undefined;
  lastInvestmentDate: CalendarDay | undefined;
  lastRevaluationDate: CalendarDay | undefined;
  holdingPeriod: number | null;
};

type Props = {
  selectedVehicle: Vehicle;
  assetPerformanceAggregations: AssetPerformanceAggregations;
};

const CompanyPerformanceOverview: React.FC<Props> = ({
  selectedVehicle,
  assetPerformanceAggregations,
}) => {
  return (
    <Column spacing="sm">
      <Typography variant="h5">Performance</Typography>
      <Row fullWidth spacing="md">
        <StyledPerformanceCard
          label="Total current value"
          value={numberToCurrencyString(
            assetPerformanceAggregations.totalCurrentValueLcy,
            {
              currency: selectedVehicle.baseCurrency,
            },
          )}
        />
        <StyledPerformanceCard
          label="Total unrealised value"
          value={numberToCurrencyString(
            assetPerformanceAggregations.totalCurrentUnrealisedValueLcy,
            {
              currency: selectedVehicle.baseCurrency,
            },
          )}
        />
        <StyledPerformanceCard
          label="Total realised value"
          value={numberToCurrencyString(
            assetPerformanceAggregations.totalCurrentRealisedValueLcy,
            {
              currency: selectedVehicle.baseCurrency,
            },
          )}
        />
      </Row>
      <Row fullWidth spacing="md">
        <StyledPerformanceCard
          label="Agg. investment cost"
          value={numberToCurrencyString(
            assetPerformanceAggregations.totalInvestmentAmountLcy,
            {
              currency: selectedVehicle.baseCurrency,
            },
          )}
        />
        <StyledPerformanceCard
          label="Gross MOIC"
          value={assetPerformanceAggregations.grossMOIC}
        />
        <StyledPerformanceCard
          label="Gross IRR"
          value={
            assetPerformanceAggregations.grossIRR !== null
              ? numberToPercentageString(
                  assetPerformanceAggregations.grossIRR,
                  { forceDecimals: true, accuracy: 2 },
                )
              : 'N/A'
          }
        />
      </Row>
    </Column>
  );
};

export default CompanyPerformanceOverview;
